import React, {useRef} from 'react';
import axios from 'axios';
import {
    CONFIRMING_WORK_EXECUTION,
    DENIED_FICHE_DEVIS, DENIEDING_WORK_EXECUTION, DOWNLOAD_DEVIS_MO,
    DOWNLOAD_FICHE_DEVIS,
    LOAD_DETAILS,
    LOAD_STATE_HISTORIES, VALIDATE_FICHE_DEVIS
} from "../../../../api/Api";
import {Redirect, useLocation, useParams} from 'react-router-dom'
import {makeStyles} from '@material-ui/core/styles';
import {convertToLocalState} from "../../../../utils/helpers";
import {FICHE_STATES} from "../../../../utils/constants";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";
import Step from "@material-ui/core/Step";
import Stepper from "@material-ui/core/Stepper";
import StateView from "../../../../components/Ui/StateView";
import NewFicheCommandeModal from "../../../../components/Modals/Fiches/NewFicheCommandeModal";
import BootstrapLoadingButton from "../../../../components/Ui/BootstrapLoadingButton";
import {canDownloadDevis, canDownloadDevisMO} from "../../../Unauthenticated/FicheDetails/FicheDetailsPage";
import FicheCommentSection from "../../../../components/Modules/Fiches/FicheCommentSection";
import moment from 'moment'
import ConfirmationModal from "../../../../components/Modals/ConfirmationModal";
import TextArea from "../../../../components/Ui/TextArea";
import FicheHistoryStepper from "./FicheHistoryStepper";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    button: {
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    actionsContainer: {
        marginBottom: theme.spacing(2),
    },
    resetContainer: {
        padding: theme.spacing(3),
    },
    details: {
        background: '#f1f1f1!important'
    },
    stateRoot: {
        width: '100%',
        border: 'none',
        borderRadius: 8,
        // padding: 18,
        background: '#f3f6f9',
        color: 'initial',
        fontSize: 12,
        fontWeight: 'normal'
    }
}));

const NORMAL_STATE_STEP = FICHE_STATES.filter(
    item => {
        return item.state !== 'App\\Models\\Fiches\\States\\StudyFinishedStep';
    }
);

const NO_COMMAND_STATE_STEP = FICHE_STATES.filter(
    item => {
        return item.state !== 'App\\Models\\Fiches\\States\\WorkInProgressStep'
            && item.state !== 'App\\Models\\Fiches\\States\\WorkFinishedStep'
            && item.state !== 'App\\Models\\Fiches\\States\\CommandSendedStep'
            ;
    }
);

function isFicheTerminedWithoutCommand(history) {
    return !!history.find(item => item.new_state == 'App\\Models\\Fiches\\States\\StudyFinishedStep')
}

function getFicheStates(history) {
    if (isFicheTerminedWithoutCommand(history))
        return NO_COMMAND_STATE_STEP;

    return NORMAL_STATE_STEP;
}

function getSteps(history) {
    return getFicheStates(history).map(item => {
        return item.state;
    });
}

function getStepContent(stepCode, history) {
    return FICHE_STATES.find(
        item => stepCode == item.state
    )?.label;
}


function findStep(stepHistory, step) {
    return stepHistory.find(
        item => item.new_state == step
    )
}

function getStepLabel(stepCode) {
    return FICHE_STATES.find(
        item => stepCode == item.state
    )?.label;
}

function isStepCompleted(stepHistory, step) {

    if (step == 'App\\Models\\Fiches\\States\\WaitingUserConfirmationStep')
        return true;

    return !!stepHistory.find(
        item => item.new_state == step
    )
}

function buildSteps(history) {


}

export default function StatePage(props) {

    const params = useParams();
    const classes = useStyles();

    const [histories, setFicheHistories] = React.useState();
    const [ficheDetails, setFicheDetails] = React.useState();
    const [isLoadingDetails, setIsLoadingDetails] = React.useState();
    const [ficheNotFound, setFicheNotFound] = React.useState(false);

    const [isAcceptingDevis, setIsAcceptingDevis] = React.useState(false);
    const [isDeniedingDevis, setIsDeniedingDevis] = React.useState(false);

    const [isConfirmingOrDenied, setIsConfirmingOrDenied] = React.useState(false);

    const [workConfirmationComment, setWorkConfirmationComment] = React.useState();
    const [shouldFillComment, setShouldFillComment] = React.useState();

    const sodeciCommandeRef = React.useRef(null)
    const cieCommandeRef = React.useRef(null);

    const location = useLocation();

    async function loadHistory() {

        try {

            setIsLoadingDetails(true);

            const response = await axios.get(
                `${LOAD_STATE_HISTORIES}/${params.id}`,
                {}
            );

            setFicheHistories(response.data);

        } catch (e) {

            // if (e.response && e.response.status === 404)
            //     setFicheNotFound(true)

        } finally {
            setIsLoadingDetails(false);
        }

    }


    const localState = React.useMemo(
        () => {
            if (histories) {
                let localState = convertToLocalState(histories.state);
                return localState;
            }
        }, [histories]
    )

    const cieHistory = React.useMemo(
        () => {
            if (histories) {
                return histories.filter(
                    item => item.societe == 'CIE'
                );
            }
        }, [histories]);

    const sodeciHistory = React.useMemo(
        () => {
            if (histories) {
                return histories.filter(
                    item => item.societe == 'SODECI'
                );
            }
        }, [histories]);


    const stepsCIE = React.useMemo(
        () => {

            if (!histories)
                return [];

            const stepArray = getSteps(cieHistory);

            return stepArray;
        }, [histories]
    );

    const stepsSODECI = React.useMemo(
        () => {

            if (!histories)
                return [];

            const stepArray = getSteps(sodeciHistory);

            return stepArray;
        }, [histories]
    );

    const activeStepCIE = React.useMemo(
        () => {
            if (histories) {

                return stepsCIE.findIndex(
                    (item) => item.state == cieHistory[cieHistory.length - 1]?.new_state
                );

            }
        }, [histories]
    )


    const activeStepSODECI = React.useMemo(
        () => {
            if (histories) {

                return stepsSODECI.findIndex(
                    (item) => item.state == sodeciHistory[sodeciHistory.length - 1]?.new_state
                );

            }
        }, [histories]
    )

    async function loadDetails() {

        try {

            setIsLoadingDetails(true);

            const response = await axios.get(
                `${LOAD_DETAILS}/${params.id}`,
                {}
            );

            setFicheDetails(response.data);

        } catch (e) {

            if (e.response && e.response.status === 404)
                setFicheNotFound(true)

        } finally {
            setIsLoadingDetails(false);
        }

    }

    async function validateFicheDevis(societe_state) {

        try {

            setIsAcceptingDevis(true);

            const response = await axios.post(`${VALIDATE_FICHE_DEVIS}/${ficheDetails.id}`, {societe_state});

            setFicheDetails(response.data)

            // window.location.reload();
            if (societe_state.toUpperCase() == 'CIE')
                cieCommandeRef.current.showCommandeModal();

            else if (societe_state.toUpperCase() == 'SODECI')
                sodeciCommandeRef.current.showCommandeModal();

        } catch (e) {

            console.log(e);

        } finally {

            setIsAcceptingDevis(false);

        }

    }

    async function deniedFicheDevis(societe_state) {

        try {

            setIsDeniedingDevis(true);

            const response = await axios.post(`${DENIED_FICHE_DEVIS}/${ficheDetails.id}`, {societe_state});

            // setFicheDetails(response.data)
            window.location.reload();

        } catch (e) {

        } finally {

            setIsDeniedingDevis(false);

        }

    }

    async function confirmeFiche(societe_state) {

        try {

            setIsConfirmingOrDenied(true);

            const response = await axios.post(`${CONFIRMING_WORK_EXECUTION}/${ficheDetails.id}`, {
                societe_state,
                comment: workConfirmationComment
            });

            window.location.reload();

        } catch (e) {

        } finally {

            setIsConfirmingOrDenied(false);

        }

    }

    async function infirmeFiche(societe_state) {

        try {

            setIsConfirmingOrDenied(true);

            const response = await axios.post(`${DENIEDING_WORK_EXECUTION}/${ficheDetails.id}`, {
                societe_state,
                comment: workConfirmationComment
            });

            window.location.reload();

        } catch (e) {

        } finally {

            setIsConfirmingOrDenied(false);

        }

    }

    React.useEffect(() => {

        loadHistory();
        loadDetails();

    }, [])

    return (
        <div className={`${classes.root}bg-white`}>

            {
                isLoadingDetails && (
                    <div>
                        En cours de chargement
                    </div>
                )
            }


            {
                ficheNotFound && (
                    <Redirect to={'/'}/>
                )
            }

            {
                histories && ficheDetails && (

                    <div className={'row'}>

                        <div className={'col-12 bg-white px-5 py-5'}>

                            <div className={'h2 text-primary'}>


                                <div className={'row mt-5'}>

                                    <div className={'col-auto'}>
                                        <div className={'font-weight-bolder h2 text-right'}>
                                            <div className={'small font-weight-light text-dark'}>Numéro de demande</div>
                                            <div className={'font-weight-bold text-success'}>
                                                {ficheDetails.code}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12">

                                    </div>

                                </div>


                            </div>

                            <div className="row">

                                {
                                    (ficheDetails.type_travaux == 1 || ficheDetails.type_travaux == 3) && (
                                        <div className="col">


                                            {
                                                (
                                                    ficheDetails.type_travaux == 1 ||
                                                    ficheDetails.type_travaux == 3) && (
                                                    <div className="col-auto my-2">

                                                        <div className={`card ${classes.stateRoot}`}>

                                                            <div className="card-body">
                                                        <span className="h5 my-4 font-weight-bold">
                                                            Evolution de la demande CIE

                                                            <div className="float-right">
                                                                <img src="/images/cie-logo.jpg" width={58} alt=""/>
                                                            </div>

                                                        </span>

                                                                <div className={'py-3 text-center'}>
                                                                    <StateView activeState={ficheDetails.state}
                                                                               states={FICHE_STATES}/>
                                                                </div>

                                                                {
                                                                    canDownloadDevis(ficheDetails.state) && (
                                                                        <a target={'_blank'}
                                                                           href={`${DOWNLOAD_FICHE_DEVIS}/${ficheDetails.id}?state=CIE`}
                                                                           className={'btn btn-primary'}>
                                                                            <i className={'flaticon2-download'}></i> Télécharger le devis
                                                                        </a>
                                                                    )
                                                                }

                                                                {
                                                                    canDownloadDevisMO(ficheDetails.state) && (
                                                                        <a target={'_blank'}
                                                                           href={`${DOWNLOAD_DEVIS_MO}/${ficheDetails.id}?state=CIE`}
                                                                           className={'btn btn-primary'}>
                                                                            <i className={'flaticon2-download'}></i> Télécharger le devis de Maître d'Ouvrage
                                                                        </a>
                                                                    )
                                                                }

                                                                {
                                                                    (ficheDetails.state == 'App\\Models\\Fiches\\States\\DevisSendedStep') && (
                                                                        <div>

                                                                            <ConfirmationModal
                                                                                text={'Êtes vous sûr de vouloir accepter le devis ?'}
                                                                                onConfirm={() => {
                                                                                    validateFicheDevis('CIE')
                                                                                }}
                                                                            >

                                                                                <BootstrapLoadingButton
                                                                                    loading={isAcceptingDevis || isDeniedingDevis}
                                                                                    className={'btn btn-light-success d-inline-block mr-3 my-2'}>
                                                                                    Accepter le devis
                                                                                </BootstrapLoadingButton>

                                                                            </ConfirmationModal>
                                                                            <ConfirmationModal
                                                                                text={'Êtes vous sûr de vouloir refuser le devis ?'}
                                                                                onConfirm={() => {
                                                                                    deniedFicheDevis('CIE')
                                                                                }}
                                                                            >

                                                                                <BootstrapLoadingButton
                                                                                    loading={isDeniedingDevis || isAcceptingDevis}
                                                                                    className={'btn btn-light-danger '}>
                                                                                    Refuser le devis
                                                                                </BootstrapLoadingButton>

                                                                            </ConfirmationModal>

                                                                        </div>
                                                                    )
                                                                }


                                                                {
                                                                    (ficheDetails.state == 'App\\Models\\Fiches\\States\\WorkFinishedStep') && (
                                                                        <div className={'mt-5'}>

                                                                            <TextArea
                                                                                placeholder={'Ajouter un commentaire'}
                                                                                onChange={(event) => {
                                                                                    setWorkConfirmationComment(event.target.value)

                                                                                    if (!!event.target.value && shouldFillComment)
                                                                                        setShouldFillComment(false)

                                                                                }}
                                                                            />

                                                                            {
                                                                                shouldFillComment && (
                                                                                    <div className="text-danger">Vous
                                                                                        devez saisir les
                                                                                        commentaires</div>
                                                                                )
                                                                            }


                                                                            <ConfirmationModal
                                                                                text={'Êtes vous sûr de vouloir confirmer la réalisation des travaux ?'}
                                                                                onConfirm={() => {
                                                                                    setShouldFillComment(false)
                                                                                    confirmeFiche('CIE')
                                                                                }}
                                                                            >

                                                                                <BootstrapLoadingButton
                                                                                    loading={isAcceptingDevis || isDeniedingDevis}
                                                                                    className={'btn btn-light-success d-inline-block mr-3 my-2'}>
                                                                                    Confirmer la réalisation des travaux
                                                                                </BootstrapLoadingButton>

                                                                            </ConfirmationModal>
                                                                            <ConfirmationModal
                                                                                text={'Êtes vous sûr de vouloir infirmer la réalisation des travaux ?'}
                                                                                onConfirm={() => {

                                                                                    if (!workConfirmationComment) {
                                                                                        setShouldFillComment(true)
                                                                                        return;
                                                                                    } else {
                                                                                        setShouldFillComment(false)
                                                                                    }

                                                                                    infirmeFiche('CIE')
                                                                                }}
                                                                            >

                                                                                <BootstrapLoadingButton
                                                                                    loading={isDeniedingDevis || isAcceptingDevis}
                                                                                    className={'btn btn-light-danger '}>
                                                                                    Infirmer la réalisation des travaux
                                                                                </BootstrapLoadingButton>

                                                                            </ConfirmationModal>

                                                                        </div>
                                                                    )
                                                                }
                                                                <div>

                                                                    <NewFicheCommandeModal
                                                                        ref={cieCommandeRef}
                                                                        societe={'CIE'}
                                                                        id={ficheDetails.id}
                                                                    >

                                                                        {
                                                                            (ficheDetails.state == 'App\\Models\\Fiches\\States\\DevisAcceptedStep') && (
                                                                                <BootstrapLoadingButton
                                                                                    className={'btn btn-success'}>
                                                                                    COMMANDER LES TRAVAUX
                                                                                </BootstrapLoadingButton>

                                                                            )
                                                                        }

                                                                    </NewFicheCommandeModal>

                                                                </div>

                                                            </div>

                                                        </div>

                                                    </div>
                                                )
                                            }


                                            <div className={'px-4 pt-5'}>
                                                <FicheHistoryStepper histories={histories} targetState={'CIE'}/>
                                            </div>

                                        </div>
                                    )
                                }


                                {
                                    (ficheDetails.type_travaux == 2 || ficheDetails.type_travaux == 3) && (
                                        <div className="col">

                                            {
                                                (
                                                    ficheDetails.type_travaux == 2 ||
                                                    ficheDetails.type_travaux == 3) && (
                                                    <div className="col-auto my-2">

                                                        <div className={`card ${classes.stateRoot}`}>

                                                            <div className="card-body">
                                                        <span className="h5 font-weight-bold">
                                                            Evolution de la demande SODECI

                                                                    <div className="float-right">
                                                                        <img src="/images/sodeci-logo.png" width={68}
                                                                             alt=""/>
                                                                    </div>

                                                        </span>

                                                                <div className={'py-3 text-center'}>
                                                                    <StateView activeState={ficheDetails.state_sodeci}
                                                                               states={FICHE_STATES}/>
                                                                </div>

                                                                {
                                                                    canDownloadDevis(ficheDetails.state_sodeci) && (
                                                                        <a target={'_blank'}
                                                                           href={`${DOWNLOAD_FICHE_DEVIS}/${ficheDetails.id}?state=SODECI`}
                                                                           className={'btn d-inline-block my-1 btn-success'}>
                                                                            <i className={'flaticon2-download'}></i> Télécharger le devis
                                                                        </a>
                                                                    )
                                                                }

                                                                {
                                                                    (ficheDetails.state_sodeci == 'App\\Models\\Fiches\\States\\DevisSendedStep') && (
                                                                        <div>

                                                                            <ConfirmationModal
                                                                                text={'Êtes vous sûr de vouloir accepter le devis ?'}
                                                                                onConfirm={() => {
                                                                                    validateFicheDevis('SODECI')
                                                                                }}
                                                                            >

                                                                                <BootstrapLoadingButton
                                                                                    loading={isAcceptingDevis || isDeniedingDevis}
                                                                                    className={'btn btn-light-success d-inline-block mr-3 my-2'}>
                                                                                    Accepter le devis
                                                                                </BootstrapLoadingButton>

                                                                            </ConfirmationModal>

                                                                            {/*<ConfirmationModal*/}
                                                                            {/*    text={'Êtes vous sûr de vouloir refuser le devis ?'}*/}
                                                                            {/*    onConfirm={()=>{deniedFicheDevis('SODECI')}}*/}
                                                                            {/*>*/}

                                                                            {/*    <BootstrapLoadingButton loading={isDeniedingDevis || isAcceptingDevis} className={'btn btn-light-danger '}>*/}
                                                                            {/*        Refuser le devis*/}
                                                                            {/*    </BootstrapLoadingButton>*/}

                                                                            {/*</ConfirmationModal>*/}


                                                                        </div>
                                                                    )
                                                                }
                                                                        <div>

                                                                            <NewFicheCommandeModal
                                                                                ref={sodeciCommandeRef}
                                                                                opened={true}
                                                                                societe={'SODECI'}
                                                                                id={ficheDetails.id}
                                                                            >

                                                                                {
                                                                                    (ficheDetails.state_sodeci == 'App\\Models\\Fiches\\States\\DevisAcceptedStep') && (
                                                                                        <BootstrapLoadingButton
                                                                                            className={'btn btn-success'}>
                                                                                            COMMANDER LES TRAVAUX
                                                                                        </BootstrapLoadingButton>

                                                                                    )
                                                                                }

                                                                            </NewFicheCommandeModal>

                                                                        </div>

                                                            </div>

                                                        </div>

                                                    </div>
                                                )
                                            }


                                            <div className={'px-4 pt-5'}>
                                                <FicheHistoryStepper histories={histories} targetState={'SODECI'}/>
                                            </div>

                                        </div>
                                    )
                                }

                            </div>


                        </div>

                        <div className="col-12 px-5 py-3">

                            <FicheCommentSection fiche={ficheDetails}/>

                        </div>


                    </div>

                )
            }

        </div>
    );

}